o_global.eventLoader.onAllScriptsExecuted(1111, function () {
    "use strict";

    if (!o_user.goodByePageInitialized && (typeof o_reco !== "undefined")) {
        o_user.goodByePageInitialized = true;

        o_user.goodByePage.presenter = o_user.goodByePage.presenterBuilder(document, o_reco.api);
        o_user.goodByePage.presenter.showRecommendationCinema();
    }
});